import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import i18n from "./i18n";
import VueParticles from "vue-particles";
import Vuelidate from 'vuelidate';


import RouterTab from 'vue-router-tab'
import 'vue-router-tab/dist/lib/vue-router-tab.css'


// import plugins from '../public/assets/js/plugins.min.js'
import VueGoodTablePlugin from "vue-good-table";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
// import the style
import "vue-good-table/dist/vue-good-table.css";
import VueSession from "vue-session";
import VueResource from "vue-resource";

Vue.use(VueResource);
Vue.use(Vuelidate);

// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
// // Make BootstrapVue available throughout your project
// Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)


import Popover from 'vue-js-popover'

Vue.use(Popover, {
  tooltip: true
})


Vue.http.options.root ="https://faramiran.com/" //"http://www.faramiran.com:8000/"   // "http://127.0.0.1:8000/"  //"http://www.faramiran.com:8000/"/;
const token = localStorage.getItem('token')
if (token) {
  Vue.http.headers.common["Authorization"] =
    "Bearer " + token
}


import VueNoty from 'vuejs-noty'

Vue.use(VueNoty, {
  layout: "bottomLeft",
  theme: "nest",
  queue: 'global',
  timeout: "4000",
  progressBar: true,
  closeWith: ["click"]
})

;
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
const swalOption={
}
Vue.use(VueSweetalert2,swalOption);

// =========================================== end vue notification ===============================

import Loading from "vue-loading-overlay";
// // Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Loading, {
  // props
  color: '#d2832d',
  loader: "dots"
}, {
  // slots
})

// import moment from "vue-moment"
// Vue.use(require('vue-moment'));

Vue.use(VueGoodTablePlugin);
Vue.use(VueSession, {
  persist: true
});
Vue.config.productionTip = false;

//Vue.use(plugins)

Vue.use(RouterTab)
Vue.use(VueParticles);
Vue.use(require('vue-jalali-moment'));

new Vue({
  router,
  store,
  i18n,
  components: {
    // popover
  },
  render: (h) => h(App)
}).$mount("#app");